import { createFileRoute } from "@tanstack/react-router";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button } from "@astryxdesign/core/Button";
import * as stylex from "@stylexjs/stylex";
import { accessAPI, errorMessage, queries } from "../lib/api";
import { AppearanceSelect } from "../lib/appearance";
import { styles } from "../lib/styles";

export const Route = createFileRoute("/approve")({ component: ApproveDevice });
function ApproveDevice() {
  const consent = useQuery(queries.consent());
  const approve = useMutation({ mutationFn: accessAPI.approveDevice });
  return (
    <div {...stylex.props(styles.loginShell)}>
      <main {...stylex.props(styles.login)}>
        <section data-workspace-panel {...stylex.props(styles.panel)}>
          <div {...stylex.props(styles.brand, styles.loginBrand)}>
            <img src="/ssbd-logo.png" width="48" height="48" alt="SSBD" />
            <span>SSBD Access</span>
          </div>
          <h1 {...stylex.props(styles.title)}>
            {approve.isSuccess
              ? approve.data.approved
                ? "Your device is approved."
                : "Request declined."
              : "Approve your SSH tool"}
          </h1>
          {approve.isSuccess ? (
            <p {...stylex.props(styles.description)}>
              Return to SSBD Access or your terminal. You may close this window.
            </p>
          ) : (
            <>
              <p {...stylex.props(styles.description)}>
                Only approve if you started the SSH tool and this code matches the one in SSBD
                Access or your terminal.
              </p>
              {consent.data && (
                <>
                  <pre {...stylex.props(styles.code)}>{consent.data.code}</pre>
                  <p {...stylex.props(styles.small)}>
                    Signed in as {consent.data.email}. Approval signs in the tool; SSH access still
                    requires it to stay running.
                  </p>
                  <div {...stylex.props(styles.actions)}>
                    <Button
                      label="Approve this device"
                      variant="primary"
                      isLoading={approve.isPending}
                      onClick={() => approve.mutate({ csrf: consent.data.csrf, approve: true })}
                    />
                    <Button
                      label="Decline"
                      isDisabled={approve.isPending}
                      onClick={() => approve.mutate({ csrf: consent.data.csrf, approve: false })}
                    />
                  </div>
                </>
              )}
              {(consent.error || approve.error) && (
                <p role="alert" {...stylex.props(styles.error)}>
                  {errorMessage(consent.error || approve.error)}
                </p>
              )}
            </>
          )}
        </section>
        <AppearanceSelect />
      </main>
    </div>
  );
}
